import { getSavedState, saveState } from './helpers.js';

export default {
    namespaced: true,

    state: () => ({
        size: getSavedState('panierRetourSize') || 0,
        canCreatePre: getSavedState('canCreatePreRetour') ?? false,
    }),

    getters: {
        size(state) {
            return state.size;
        },
        canCreatePre(state) {
            return state.canCreatePre;
        },
    },

    mutations: {
        SET_SIZE(state, newValue) {
            state.size = newValue;
            saveState('panierRetourSize', newValue);
        },
        SET_CAN_CREATE_PRE(state, newValue) {
            state.canCreatePre = newValue;
            saveState('canCreatePreRetour', newValue);
        },
    },

    actions: {
        setSize({ commit }, newValue) {
            commit('SET_SIZE', newValue);
        },
        setCanCreatePre({ commit }, newValue) {
            commit('SET_CAN_CREATE_PRE', newValue);
        },
    },
};